import React, { useState, useEffect, useReducer } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MROButton from "../../../../components/buttons";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/core/styles";
import { format24HrDateTime, formatDateTime, getOrganisationId } from "../../../../lib/utils/common_utils";
import ManageDataDialog from "../../../../components/form_components/manage_data_dialog";
import DataService from "../../../../lib/services/api";
import { act } from "react-dom/test-utils";
import MROTextField from "../../../../components/form_components/TextField";
import { Autocomplete } from "@material-ui/lab";
import { useContext } from "react";
import { ToastMessageContext } from "../../../../lib/contexts/message_context";
import { CircularProgress, FormControlLabel, InputAdornment, Menu, MenuItem, Switch, IconButton } from "@material-ui/core";
import DateTimeField from "components/form_components/DateTimeField";
import VerticalIcon from '@material-ui/icons/MoreVert';
import alertIcon from 'assets/icons/Alert_icon.png'
import DataServiceAction from "actions/data_actions";
import tableReducer, { INITIAL_TABLE_STATE } from "reducers/table_reducer";
import LineCustomerService from "lib/services/api/admin/line/line_customers_client";
import useStopAllJobClockings from "views/Operations/Job Clockings/Live/useStopAllJobClocking";


const useStyles = makeStyles(theme => ({
    paper: {
        backgroundColor: '#fff',
        padding: theme.spacing(3),
        boxShadow: "0px 1px 4px #0000001A"
    },
    items: {
        margin: "6px 0px"
    },
    formControlLabel: {
        margin: '13px 0px',
        marginLeft: 0,
        display: "flex",

        "& .MuiSwitch-root": {
            marginLeft: "auto",
        },
    },
}))

function GeneralWorkOrderDetails(props) {
    const classes = useStyles();
    const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
    const { data, apiEndpoint, paramName, lineCustomerId, regCharactersLength } = props;
    const [workOrder, setWorkOrder] = useState({})
    const [action, setAction] = useState(null)
    const [loading, setLoading] = useState(false);
    const message = useContext(ToastMessageContext);
    const [groupTypes, setGroupTypes] = useState([]);
    const [selectedAtaFilter, setSelectedAtaFilter] = useState({});
    const [scheduelDueDate, setScheduelDueDate] = useState(false);
    const [scheduelDate, setScheduelDate] = useState()
    const [errors, setErrors] = useState({});
    const [tempData, setTempData] = useState({
        approval_type: '',
        aircraft_registration: ''
    })
    const [anchorEl, setAnchorEl] = useState(false);
    const [open, setOpen] = useState(false)
    const [currSectionLabelValueKey, setCurrSectionLabelValueKey] = useState({ label: "Work Order Number", key: "work_order_number" });
    const [deloading, setDeleteLoading] = useState(false);

    useEffect(() => {
        if (paramName === "delay_number") {
            setCurrSectionLabelValueKey({ label: 'Delay Number', key: "delay_number" })
        }
        if (paramName === "call_out_number") {
            setCurrSectionLabelValueKey({ label: 'Callout Number', key: "call_out_number" })
        }
    }, [paramName])

    useEffect(() => {
        if (data) {
            setTempData({
                ...data,
                aircraft_registration: data.aircraft_registration,
                approval_type: {
                    id: data.approval_type_id,
                    type_name: data.approval_type
                }
            })
        }
    }, [])

    const handleClose = () => {
        setAction(null);
        props.getList();
        setErrors({})
        // props.handleClose();
    }
    const handleClose1 = () => {
        setAction(null);
        setOpen(false)
        setAnchorEl(false)

    }
    useEffect(() => {
        setTempData({
            ...data,
            aircraft_registration: data.aircraft_registration,
            approval_type: {
                id: data.approval_type_id,
                type_name: data.approval_type
            }
        })
    }, [])


    const validateFields = (formData) => {
        let valid = true;
        let error = {};



        for (let pair of formData.entries()) {
            const key = pair[0];
            const value = pair[1];

            if (value === "") {
                error[key] = true
                valid = false
            }
        }

        const aircraft_registration = formData.get("aircraft_registration");


        const length = tempData.aircraft_registration?.replace(data.prefix, '')?.length;


        // console.log("data ===", aircraft_registration, aircraft_registration.length, length)

        if (aircraft_registration?.length === 0 && length === 0) {
            valid = true;
            setErrors(e => ({ ...e, aircraft_registration: false }));
        }
        else if (aircraft_registration?.length > 0 && length === 0) {
            valid = true;
            setErrors(e => ({ ...e, aircraft_registration: false }));
        }

        else if (aircraft_registration?.length !== regCharactersLength && aircraft_registration !== "") {
            setErrors(e => ({ ...e, aircraft_registration: `The number of characters should be exactly ${regCharactersLength}, neither more nor less` }));
            valid = false;
        }

        if (!valid) {
            setErrors(e => ({ ...e, ...error }))
        }

        return valid;
    }

    const handleSubmit = (formData) => {

        formData.append(paramName, data[paramName])
        apiEndpoint === "updateWorkOrder" && formData.append('scheduled_date', data.scheduled_date)
        formData.append('date', data.date)
        formData.append('line_customer_id', data.line_customer_id)
        formData.append('id', data.id)
        formData.append('approval_type_id', selectedAtaFilter?.approval_type_id)
        // formData.append("scheduled_due_date", scheduelDueDate)
        if (scheduelDueDate) {
            formData.append('scheduled_date', scheduelDate)
        } else {
            formData.delete('scheduled_date')
        }
        const aircraft_registration = formData.get("aircraft_registration");

        if (!validateFields(formData)) return;
        formData.delete('aircraft_registration')

        // console.log("data-------", data?.prefix)

        formData.append("aircraft_registration", aircraft_registration?.length === 0 ? "" : `${data?.prefix === null ? "" : data?.prefix}${aircraft_registration}`.toUpperCase());

        setLoading(true);
        DataService.updateData(formData, null, apiEndpoint).then(res => {
            // console.log('res', res)
            setLoading(false)
            setTempData({
                ...tempData,
                aircraft_registration: res.data.aircraft_registration,
                base_station_id: res.data?.base_station_id,
                approval_type: {
                    id: res.data.approval_type_id,
                    type_name: res.data.approval_type
                }
            })
            if (res.success) {
                message.showToastMessage({ message: 'updated successfully', variant: 'success' })
            } else {
                message.showToastMessage({ message: res?.message, variant: 'error' })
            }
            handleClose()
        }).catch(err => {
            setLoading(false)
            handleClose()
        })
    }


    useEffect(() => {
        if (lineCustomerId) {
            LineCustomerService.fetchWorkOrderDependencies(lineCustomerId)
                .then((res) => {
                    if (res.success) {
                        setGroupTypes(res.approval_types)
                        setSelectedAtaFilter(res.approval_types.find(type => type.type_name === data.approval_type))
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

        }
    }, [lineCustomerId]);
    // useEffect(() => {
    //     DataService.getData({}, 'approvalType').then(res => {
    //         if (res.data) {
    //             setGroupTypes(res.data)
    //             setSelectedAtaFilter(res.data.find(type => type.type_name === data.approval_type))
    //         } else {
    //             message.showToastMessage({ message: 'Unable to update workorder!', variant: 'error' })
    //         }
    //     }).catch(err => {
    //         message.showToastMessage({ message: 'Unable to update workorder!', variant: 'error' })
    //     });

    // }, [])

    useEffect(() => {

        setScheduelDueDate(data?.scheduled_due_date);
        data?.scheduled_date && setScheduelDate(data?.scheduled_date);

    }, [data])

    const handleDelete = (formData) => {
        let pin = formData.get("admin_pin")
        if (formData && pin === "") {
            setErrors(e => ({ ...e, admin_pin: 'Please enter adminstration pin' }));
        }
        else if (formData && pin !== "23021981") {
            setErrors(e => ({ ...e, admin_pin: 'Incorrect Pin' }));
        }
        if (formData && pin === "23021981") {
            setDeleteLoading(true)

            DataServiceAction.deleteData(
                dispatch,
                message,
                "",
                { id: data.id },
                "destroyWorkOrder",
                props.handleClose,
                null,
                props.getList
            );
        }
    }
    const { stopClockIn } = useStopAllJobClockings(
        {
            action: "STOP_ALL",
            organisation_id: getOrganisationId(),
            work_order_id: data.id
        },
        {
            handleClose: handleClose,
        }
    );
    const handleStopJobClockings = () => {
        stopClockIn()
    }

    return (
        <div className={classes.paper}>
            <Grid container spacing={5} alignItems={"center"} justify={"space-between"}>
                <Grid item md={4}>
                    <div className={"align-left-space-between flex-center"} style={{ width: '100%' }}>
                        <Typography variant={"subtitle1"}>Airline</Typography>
                        <Typography variant={"subtitle2"}>{data.airline || "-"}</Typography>
                    </div>
                    <div className={"align-left-space-between flex-center"} style={{ width: '100%' }}>
                        <Typography variant={"subtitle1"}>{currSectionLabelValueKey.label}</Typography>
                        <Typography variant={"subtitle2"}>{data[currSectionLabelValueKey.key] || "-"}</Typography>
                    </div>
                    <div className={"align-left-space-between flex-center"} style={{ width: '100%' }}>
                        <Typography variant={"subtitle1"}>User Stamp#</Typography>
                        <Typography variant={"subtitle2"}>{data.stamp_number || "-"}</Typography>
                    </div>
                </Grid>
                <Grid item md={4}>
                    <div className={"align-left-space-between flex-center"} style={{ width: '100%' }}>
                        <Typography variant={"subtitle1"}>Aircraft Registration</Typography>
                        <Typography variant={"subtitle2"}>{tempData.aircraft_registration || "-"}</Typography>
                    </div>
                    <div className={"align-left-space-between flex-center"} style={{ width: '100%' }}>
                        <Typography variant={"subtitle1"}>Aircraft Type</Typography>
                        <Typography variant={"subtitle2"}>{tempData.approval_type.type_name || "-"}</Typography>
                    </div>
                    <div className={"align-left-space-between flex-center"} style={{ width: '100%' }}>
                        <Typography variant={"subtitle1"}>Date</Typography>
                        <Typography variant={"subtitle2"}>{format24HrDateTime(data.created_at) || "-"}</Typography>
                    </div>
                </Grid>
                <Grid item md={4} className={"align-right"}>
                    <IconButton onClick={(event) => {
                        setAnchorEl(true);
                        setOpen(true)

                    }}>
                        <VerticalIcon size="small" />
                    </IconButton>
                    {open &&
                        <Menu id={`long-menu`}
                            anchorEl={anchorEl}
                            // keepMounted
                            open={open}
                            className={classes.menu}
                            onClose={handleClose1}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            transformOrigin={{ horizontal: "right" }}
                            style={{
                                marginTop: '111px',
                                marginLeft: '-80px'
                            }}
                            PaperProps={{
                                style: {
                                    maxHeight: 45 * 4.5,
                                    width: "27ch",
                                },
                            }}
                        >

                            <MenuItem onClick={() => {
                                setOpen(false)
                                setAction('edit')
                            }}>
                                <Typography style={{ paddingLeft: '2px', cursor: !props?.permission?.write && 'none' }} >Edit Header</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                setAction('delete')
                            }}>

                                <Typography style={{ paddingLeft: '2px' }} >Delete Work Order</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                handleStopJobClockings()
                            }}>

                                <Typography style={{ paddingLeft: '2px' }} >Stop ALL Job Clockings</Typography>
                            </MenuItem>

                        </Menu >


                    }
                    {/* <MROButton variant={"contained"} onClick={() => setAction('edit')} disabled={!props?.permission?.write} color={"primary"} startIcon={<EditIcon />}>Edit</MROButton> */}
                </Grid>
            </Grid>
            {
                action === 'edit' && <ManageDataDialog loading={loading} action={action} type={"Update"} handleClose={handleClose} handleSubmit={handleSubmit} noTitle>
                    <Grid container >
                        <Grid item xs={12}>
                            <Typography color="primary" style={{ fontSize: 20, marginBottom: 15 }}>Update Work Order</Typography>
                        </Grid>

                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">Airline</Typography></Grid>
                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">{data.airline ?? "-"}</Typography></Grid>
                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">Work Order Number</Typography></Grid>
                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">{data.work_order_number ?? "-"}</Typography></Grid>

                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">User Stamp#</Typography></Grid>
                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">{data.stamp_number ?? "-"}</Typography></Grid>
                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">Date</Typography></Grid>
                        <Grid className={classes.items} item xs={6}><Typography color="primary" variant="body1">{format24HrDateTime(data.created_at) ?? "-"}</Typography></Grid>

                        {/* <Grid item xs={12} style={{ marginTop: 15 }}>
                            <FormControlLabel
                                className={classes.formControlLabel}
                                control={
                                    <Switch

                                        checked={scheduelDueDate}
                                        onChange={(e) => setScheduelDueDate(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={<Typography color="primary" style={{ fontWeight: "bold", fontSize: 16 }}>Schedule Due Date</Typography>}
                                labelPlacement="start"
                            />
                        </Grid> */}

                        {/* <Grid item xs={12}>
                            {scheduelDueDate && (
                                <DateTimeField
                                    fullWidth
                                    format="ll - HH:mm"
                                    label={"Scheduled Date"}
                                    name="scheduled_date"
                                    value={scheduelDate}
                                    defaultValue={scheduelDate}
                                    // format="ll - HH:mm"
                                    // inputProps={inputProps}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(date) => setScheduelDate(date)}
                                // errors={props.errors}
                                // setErrors={props.setErrors}
                                // style={
                                //   inputProps.readOnly
                                //     ? { opacity: 0.55, cursor: "not-allowed !important" }
                                //     : {}
                                // }
                                />
                            )}
                        </Grid> */}

                        <Grid item xs={12}>
                            <MROTextField
                                name="aircraft_registration"
                                label="Aircraft Registration"
                                InputLabelProps={{ shrink: true }}
                                required
                                inputProps={{ maxLength: regCharactersLength === 0 ? 10 : regCharactersLength }}
                                defaultValue={tempData.aircraft_registration?.replace(data.prefix, '')}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography
                                                color="primary"
                                                style={{ marginRight: "6px", fontWeight: "bold" }}
                                            >
                                                {data?.prefix}
                                            </Typography>
                                        </InputAdornment>
                                    ),
                                }}
                                autoFocus={errors.aircraft_registration}
                                error={errors.aircraft_registration}
                                helperText={errors.aircraft_registration && (typeof errors.aircraft_registration === "boolean" ? "Please enter Aircraft Registration" : errors.aircraft_registration)}
                                onChange={(e) => {
                                    setErrors(e => ({ ...e, aircraft_registration: null }));
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                getOptionSelected={(option, value) => option?.approval_type_id === value?.approval_type_id}
                                value={(selectedAtaFilter && selectedAtaFilter.approval_type_id) ? selectedAtaFilter : groupTypes.find(type => type.type_name === tempData.approval_type)}
                                onChange={(event, value) => {
                                    setSelectedAtaFilter(value);
                                    setErrors(e => ({ ...e, approval_type_id: null }));
                                }}
                                id="tags-standard"
                                name={"approval_type_id"}
                                options={groupTypes}
                                getOptionLabel={(option) => option.type_name ?? ""}
                                renderInput={(params) => (
                                    <MROTextField
                                        {...params}
                                        name={"approval_type_id"}
                                        style={{ backgroundColor: '#fff' }}
                                        variant="outlined"
                                        label="Aircraft Type"
                                        color={"primary"}
                                        placeholder={"All"}
                                        InputLabelProps={{ shrink: true }}
                                        autoFocus={errors.approval_type_id}
                                        error={errors.approval_type_id}
                                        helperText={errors.approval_type_id && "Please Select Aircraft Type"}
                                        onChange={(e) => {
                                            setErrors(e => ({ ...e, approval_type_id: null }));
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <MROTextField
                                defaultValue={tempData?.base_station_id}
                                name={"base_station_id"}
                                label={"Base"}
                                select
                                InputLabelProps={{ shrink: true }}
                                className={classes.inputField}
                                style={{ marginBottom: 27 }}
                                fullWidth
                                autoFocus={errors.base_station_id}
                                error={errors.base_station_id}
                                helperText={errors.base_station_id && "Please Select Base"}
                                onChange={(e) => {
                                    setErrors(e => ({ ...e, base_station_id: null }));
                                }}
                            >
                                {props.bases?.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.station}
                                    </MenuItem>
                                ))}
                            </MROTextField>
                        </Grid>
                    </Grid>
                </ManageDataDialog>
            }
            {action === 'delete' && <ManageDataDialog loading={deloading} action={action} type={"Complete"} handleClose={handleClose} handleSubmit={handleDelete} noTitle>
                <Grid item xs={12}>
                    <Typography color="primary" style={{ fontSize: 20, marginBottom: 15 }}>Delete Work Order</Typography>
                </Grid>
                <Grid className={classes.items} item xs={12} container>
                    <img src={alertIcon} height="15px" style={{ marginTop: '5px' }} />  <Typography variant="body1" style={{ paddingLeft: '5px' }}> This cannot be undone. Are you really sure?</Typography></Grid>

                <Grid item xs={12}>
                    <MROTextField
                        name="admin_pin"
                        label="Admin PIN "
                        placeholder={"Enter administration pin"}
                        InputLabelProps={{ shrink: true }}
                        required
                        inputProps={{ maxLength: 15 }}
                        autoFocus={errors.admin_pin}
                        error={errors.admin_pin}
                        helperText={errors.admin_pin}
                        onChange={(e) => {
                            setErrors(e => ({ ...e, admin_pin: null }));
                        }}
                    />
                </Grid>
            </ManageDataDialog>}
        </div>
    )
}

export default GeneralWorkOrderDetails;